import { render, staticRenderFns } from "./ProductBaseInfo.vue?vue&type=template&id=5f426ad7&"
import script from "./ProductBaseInfo.vue?vue&type=script&lang=js&"
export * from "./ProductBaseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports